import React from 'react';
import { List, Create, Edit, Datagrid, SimpleForm, 
  ReferenceInput, SelectInput, TextField, 
  EditButton, TextInput, Button, Filter } from 'react-admin';
import { Link } from 'react-router-dom';
import { Pagination } from 'react-admin';
import { parse } from 'query-string';
import CloseToolbar from './../lib/CloseToolbar';
import { SanitizedDiv } from '../lib/SanitizedForm';
//import ContentAdd from '@material-ui/icons/Add';
import Backspace from '@material-ui/icons/Backspace';

const ListFilter = (props) => (
<Filter {...props} >
  <ReferenceInput source="id_cave" label="Höhle auswählen" reference="cave"
    perPage={10000} sort={{ field: 'cave_name', order: 'ASC' }} alwaysOn>
    <SelectInput optionText="cave_name" />
  </ReferenceInput>
</Filter>
);
      
const PostPagination = props => <SanitizedDiv style={{marginTop:'1em',marginLeft:'1em'}}>
  <ReturnButton />
  <Pagination {...props} />
</SanitizedDiv>

const ReturnButton = ({ 
  record,
  variant = 'contained', 
  icon = <Backspace style={{marginRight: '0.5em', fontSize:'24px'}} />,
}) => (
  <Button
    component={Link}
    to={{
      pathname: 'cave',
    }}
    label='ra.action.back'
    variant={variant}
    style={{float:'left', marginRight:'1em'}}
  >
    {icon}
  </Button>
);

const ListForm = ({ permissions, ...props }) => {
  /*actions={<ListActions />}*/
  return (
  <List {...props} title="Gebiete" sort={{ field: 'cavepart_name', order: 'ASC' }} filters={<ListFilter />} pagination={<PostPagination />} filterDefaultValues={{id_cave:-1}} exporter={false} >
    <Datagrid style={{ width: 'auto' }}>
      <TextField source="cavepart_name" label="Gebiet"/>
      <TextField source="tour_anz" label="Touren"/>
      <TextField source="last_tour" label="Letzte Tour"/>
      <TextField source="id" />
      {permissions && permissions.isAdmin && <EditButton />}
    </Datagrid>
  </List>
  );
}

const redirect = (basePath, id, data) => {
  //console.log(['1',basePath, id, data]);
  if(!data) {
    console.log(parse.pro)
    return "/cave/";
  }
  return `/cave/${data.id_cave}/edit`;
}

const CEForm = ({classes, hasList, hasEdit, hasCreate, hasShow, ...props}) => {
  const { id_cave: id_cave_string } = parse(props.location.search);
  const id_cave = id_cave_string ? parseInt(id_cave_string, 10) : '';
  //console.log(id_cave);
  return (
    <SimpleForm initialValues={{ id_cave }} toolbar={<CloseToolbar nextstep={redirect} redir={"/cave/"+props.record.id_cave} />} {...props} >
      <TextField source="id" />
      <ReferenceInput source="id_cave" label="Höhle" reference="cave"
        perPage={1000} sort={{ field: 'cave_name', order: 'ASC' }} fullWidth >
        <SelectInput optionText="cave_name" disabled />
      </ReferenceInput>
      <TextInput source="cavepart_name" label="Gebiet" />
      <TextField source="tour_anz" label="Anzahl Touren" />
      <TextField source="last_tour" label="Lettze Tour" />
    </SimpleForm>
  )
};

export default {
  
  options: { label: "Höhlengebiete" },
  
  list: (props) => (
    <ListForm {...props} title="Höhlengebiete" />
  ),
  
  create: (props) => (
    <Create {...props} title="Gebiet hinzufügen">
      <CEForm {...props} />
    </Create>
  ),
  
  edit: (props) => (
    <Edit title="Gebiet bearbeiten" undoable={false} {...props}>
      <CEForm {...props} />
    </Edit>
  )
}   
